// extracted by mini-css-extract-plugin
export var centerText = "_8g-8";
export var container = "_8g-0";
export var doughnutContainer = "_8g-7";
export var legend = "_8g-a";
export var legendItemColorDisplay = "_8g-b";
export var legendItemLabel = "_8g-d";
export var legendItemValue = "_8g-c";
export var lg = "_8g-5";
export var maxWidth = "_8g-9";
export var md = "_8g-4";
export var responsive = "_8g-6";
export var sm = "_8g-3";
export var xs = "_8g-2";
export var xxs = "_8g-1";